module.exports = __webpack_public_path__ + "img/examine-refuse.a40edbd3.png";